var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pb-0 pt-0"
                },
                [_vm._v("Applications")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "text-md-right pb-2",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  staticClass: "mt-1",
                  attrs: {
                    tile: "",
                    color: "primary",
                    to: {
                      name: "applications_deploy"
                    }
                  }
                },
                [_vm._v(" Deploy new app ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("applications-operations", {
        on: {
          done: _vm.onOperationDone
        }
      }),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "py-10 text-center",
              attrs: {
                role: "status"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "36",
                  width: "3",
                  "aria-hidden": "true"
                }
              }),
              _c(
                "div",
                {
                  staticClass: "apps__muted mt-2"
                },
                [_vm._v("Finding your apps…")]
              )
            ],
            1
          )
        : !_vm.servers.length
        ? _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "py-10 text-center"
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        size: "48",
                        color: "primary",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-docker")]
                  ),
                  _c(
                    "h2",
                    {
                      staticClass: "body-1 font-weight-medium mt-2 mb-1"
                    },
                    [_vm._v("No apps yet")]
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "apps__muted mb-4"
                    },
                    [
                      _vm._v(
                        " Install apps like WordPress, Uptime Kuma or Gitea in a few clicks. If you don't have a server for them yet, we'll set one up with Docker as part of your first app. "
                      )
                    ]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        tile: "",
                        color: "primary",
                        to: {
                          name: "applications_deploy"
                        }
                      }
                    },
                    [_vm._v(" Deploy your first app ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.servers, function(s) {
        return _c(
          "gg-card",
          {
            key: s.id,
            staticClass: "mb-4",
            attrs: {
              tag: "section",
              "aria-label": "Apps on " + s.name
            }
          },
          [
            _c(
              "gg-card-header",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          md: "6"
                        }
                      },
                      [
                        _c(
                          "h2",
                          {
                            staticClass: "apps__server-name"
                          },
                          [_vm._v(_vm._s(s.name))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "caption"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                [s.ip, s.location]
                                  .filter(function(v) {
                                    return v && v !== "—"
                                  })
                                  .join(" · ")
                              )
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex flex-sm-row flex-column justify-end align-start gap-sm align-md-center",
                        attrs: {
                          md: "6"
                        }
                      },
                      [
                        _c(
                          "gg-btn",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              secondary: "",
                              to: {
                                name: "hosting_kvm_info",
                                params: {
                                  hostingid: s.id
                                }
                              }
                            }
                          },
                          [_vm._v("Open server")]
                        ),
                        _c(
                          "gg-btn",
                          {
                            attrs: {
                              disabled: !!_vm.unavailable(s),
                              to: {
                                name: "applications_deploy",
                                query: {
                                  server: s.id
                                }
                              }
                            }
                          },
                          [_vm._v(" Deploy app here ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-card-text",
              [
                _vm.installing(s)
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-2 apps__alert",
                        attrs: {
                          type: "info",
                          dense: "",
                          text: "",
                          role: "status"
                        }
                      },
                      [
                        _vm._v(
                          " Installing " +
                            _vm._s(s.install.name) +
                            "… it was chosen with this server and is installed automatically once the server is ready. "
                        )
                      ]
                    )
                  : s.install && s.install.state === "failed"
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-2 apps__alert",
                        attrs: {
                          type: "warning",
                          dense: "",
                          text: ""
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              s.install.error ||
                                "".concat(
                                  s.install.name,
                                  " couldn't be installed."
                                )
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.unavailable(s)
                  ? _c(
                      "p",
                      {
                        staticClass: "apps__muted mb-0"
                      },
                      [_vm._v(_vm._s(_vm.unavailable(s)))]
                    )
                  : _vm.apps[s.id] &&
                    _vm.apps[s.id].loading &&
                    !_vm.apps[s.id].rows
                  ? _c(
                      "div",
                      {
                        staticClass: "py-4 text-center",
                        attrs: {
                          role: "status"
                        }
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            color: "primary",
                            size: "24",
                            width: "2",
                            "aria-hidden": "true"
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "apps__sr"
                          },
                          [_vm._v("Loading apps…")]
                        )
                      ],
                      1
                    )
                  : _vm.apps[s.id] && _vm.apps[s.id].error
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-0 apps__alert",
                        attrs: {
                          type: "warning",
                          dense: "",
                          text: ""
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.apps[s.id].error) + " "),
                        _c(
                          "gg-btn",
                          {
                            staticClass: "ml-2",
                            attrs: {
                              "x-small": "",
                              text: ""
                            },
                            on: {
                              click: function click($event) {
                                return _vm.loadApps(s)
                              }
                            }
                          },
                          [_vm._v("Try again")]
                        )
                      ],
                      1
                    )
                  : _vm.apps[s.id] &&
                    _vm.apps[s.id].rows &&
                    !_vm.apps[s.id].rows.length
                  ? _c(
                      "p",
                      {
                        staticClass: "apps__muted mb-0"
                      },
                      [_vm._v("No apps on this server yet.")]
                    )
                  : _vm.apps[s.id] && _vm.apps[s.id].rows
                  ? _c("v-data-table", {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.apps[s.id].rows,
                        "item-key": "name",
                        "hide-default-footer": "",
                        "disable-pagination": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.name",
                            fn: function fn(_ref) {
                              var a = _ref.item
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex align-center"
                                  },
                                  [
                                    _c("kvm-logo", {
                                      staticClass: "mr-2",
                                      attrs: {
                                        item: a.app || {
                                          slug: a.name
                                        },
                                        size: 22,
                                        "default-icon": "mdi-docker"
                                      }
                                    }),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "ggs-item-title",
                                            attrs: {
                                              to: {
                                                name: "applications_app",
                                                params: {
                                                  serviceId: s.id,
                                                  app: a.name
                                                }
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  (a.app && a.app.name) ||
                                                    a.name
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        a.app &&
                                        a.app.name &&
                                        a.app.name !== a.name
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "caption"
                                              },
                                              [_vm._v(_vm._s(a.name))]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "item.status",
                            fn: function fn(_ref2) {
                              var a = _ref2.item
                              return [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "pb-1",
                                    attrs: {
                                      small: "",
                                      color: _vm.statusColor(a.status),
                                      "aria-hidden": "true"
                                    }
                                  },
                                  [_vm._v("mdi-circle")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "pl-1"
                                  },
                                  [_vm._v(_vm._s(_vm.statusText(a.status)))]
                                )
                              ]
                            }
                          },
                          {
                            key: "item.address",
                            fn: function fn(_ref3) {
                              var a = _ref3.item
                              return [
                                a.app && a.app.url
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: a.app.url,
                                          target: "_blank",
                                          rel: "noopener"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.shortUrl(a.app.url)))]
                                    )
                                  : _c("span", [_vm._v("—")])
                              ]
                            }
                          },
                          {
                            key: "item.actions",
                            fn: function fn(_ref4) {
                              var a = _ref4.item
                              return [
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      "aria-label":
                                        "Manage " +
                                        ((a.app && a.app.name) || a.name),
                                      to: {
                                        name: "applications_app",
                                        params: {
                                          serviceId: s.id,
                                          app: a.name
                                        }
                                      }
                                    }
                                  },
                                  [_vm._v(" Manage ")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }